import { createStore } from "@tredespace/ui/lib";

export type ReferenceState = Readonly<{
  /** Summary of the loaded model, or null when none is loaded. */
  info: string | null;
  error: string | null;
  /** Metres per file unit. */
  unit: number;
  /** 0–100. */
  opacity: number;
  /** Recentre on the origin — off by default, it forfeits alignment with the source file. */
  centre: boolean;
  collide: boolean;
  loading: boolean;
}>;

export const referenceState = createStore<ReferenceState>({
  info: null,
  error: null,
  unit: 1,
  opacity: 100,
  centre: false,
  collide: true,
  loading: false,
});
